/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseListpreisAuslandPos } from '../../models/response-listpreis-ausland-pos';

export interface GetListpreisAusland$Params {
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
  id?: string;
  netAmount?: string;
  creationDate?: string;
  country?: string;
  codeOfGoods?: string;
}

export function getListpreisAusland(http: HttpClient, rootUrl: string, params?: GetListpreisAusland$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseListpreisAuslandPos>> {
  const rb = new RequestBuilder(rootUrl, getListpreisAusland.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
    rb.query('id', params.id, {});
    rb.query('netAmount', params.netAmount, {});
    rb.query('creationDate', params.creationDate, {});
    rb.query('country', params.country, {});
    rb.query('codeOfGoods', params.codeOfGoods, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseListpreisAuslandPos>;
    })
  );
}

getListpreisAusland.PATH = '/listpreisAusland';
